import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Card,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Space,
  Badge,
  Popconfirm,
  Empty,
  Select
} from "antd";
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import CustomTable from '../../components/table/custom-table';
import { useCreatedSort, withCreatedColumn } from '../../shared/functional/created-sort';
import AddEditBannerDialog from "./AddEditBannerDialog";
import fileUtils from "../../utils/file-utils";
import { groupType, PREVIEW_TYPE } from "../../constants/app-constants";
import bannerService from "../../services/banner-service";
import arrayMove from 'array-move';
// import bannerPreviewAction from "../../redux/action/banner-action";
import SortableList from "../../components/sort/sortable-list";
import userService from "../../services/user-service";
import { openWebsitePreview } from "../../utils/preview-utils";

const { Panel } = Collapse;
const { Option } = Select;

/**
 * NMU-526: the state "ล้างค่า" restores. Named so the reset and the initial
 * state can never drift apart — every filter the form can set has to appear
 * here, or clearing would silently leave that one applied.
 */
const EMPTY_CONDITION = { title: null, status: null, createBy: null };

function callback(key) {
  console.log(key);
}

const Banner = () => {
  const dispatch = useDispatch();
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [editData, setEditData] = useState(null);
  const [condition, setCondition] = useState({ ...EMPTY_CONDITION });
  const [dataList, setDataList] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, rowPerPage: 10, rowCount: 0 });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [displayList, setDisplayList] = useState([]);
  const [userList, setUserList] = useState([]);

  /*
    NMU-580: the วันที่/เวลาสร้าง column and the sort behind it.

    The server does the ordering — this table shows one page of many — so a
    click re-runs the search in the new order, back on page 1: the newest
    record is not on page 3 of the same list read the other way round.
  */
  const { sort, createdColumn, onChangeTable } = useCreatedSort((next) =>
    doSearch(1, { condition, sort: next }));

  const columns = [
    {
      title: "ชื่อแบนเนอร์",
      dataIndex: "title",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "รูปภาพ",
      key: "image",
      render: ({ bannerId, attachImage }) => {
        return (
          attachImage && attachImage?.originalFilename ?
            (<img className="w-100"
              src={fileUtils.getFileRenderUrl(groupType.BANNER, bannerId, attachImage.originalFilename)}>
            </img>) : null
        );
      },
    },
    {
      title: "ลิงค์",
      dataIndex: "url",
      key: "url",
      render: (data) => {
        return (
          <a
            href="#"
            onClick={() => {
              window.open(
                data,
                'winname',
                'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no'
              );
            }}>
            ลิงค์
          </a>
        );
      },
    },
    {
      title: 'จำนวนผู้เข้าชม',
      dataIndex: 'totalView',
      key: 'totalView',
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Badge color={text ? '#4A9A0F' : '#CBCACA'} className="text-nowrap" text={text ? 'Online' : 'Offline'} />
      ),
    },
    {
      title: "ผู้บันทึก",
      key: "createBy",
      dataIndex: "createBy",
      render: (createBy) => {
        let check = userList.find((user) => createBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },
    {
      title: "ผู้แก้ไข",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (updateBy) => {
        let check = userList.find((user) => updateBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },
    {
      title: 'ดำเนินการ',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <Space size="middle">
          <a onClick={() => onClickEdit(record)} className="pe-3 border-end">
            <Icon.Edit size={18} />
          </a>

          <Popconfirm
            title="ยืนยันการลบข้อมูล ?"
            onConfirm={() => onConfirmDelete(record.bannerId)}
            okText="ยืนยัน"
            cancelText="ยกเลิก" >
            <a>
              <Icon.Trash size={18} />
            </a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    async function initData() {
      const response = await userService.search();
      setUserList(response.list);
    }
    initData();
    doSearch(1);
    doSearchDisplay();
  }, []);

  useEffect(() => {
    if (editData) {
      onEdit(editData);
    }
  }, [editData]);

  const onAdd = () => {
    setEditData(null);
    setIsShowAddFileDialog(true);
  };

  const onCancel = () => {
    setIsShowAddFileDialog(false);
    setEditData(null);
  };

  /**
   * NMU-439: the arrangement above holds its own copy of each banner, fetched
   * separately from the table below. Refreshing only the table left a card
   * showing the title, image and status the banner had *before* the edit —
   * which is the mismatch between the two sections that was reported.
   */
  const onSaveComplete = () => {
    setEditData(null);
    setIsShowAddFileDialog(false);
    doSearch(1);
    doSearchDisplay();
  };

  const onEdit = (data) => {
    setEditData(data);
    setIsShowAddFileDialog(true);
  }

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value });
  }

  const onChangePage = (currentPage) => {
    doSearch(currentPage);
  }

  /**
   * @param currentPage page to land on, 1 to start over.
   * @param overrides   NMU-526: search with these filters instead of the ones in
   *   state. setCondition only takes effect on the next render, so a caller that
   *   resets the filters and searches in the same handler would otherwise re-run
   *   the search it just cleared.
   */
  const doSearch = async (currentPage, overrides) => {
    try {
      const activeSort = overrides && overrides.sort ? overrides.sort : sort;
      const newPaginate = {
        ...pagination,
        currentPage: currentPage ? currentPage : pagination.currentPage,
        // NMU-580: the order travels with the page — see created-sort.js.
        ...activeSort,
      };

      dispatch(appLoaderAction.enable());

      const activeCondition = overrides ? overrides.condition : condition;

      // NMU-525: keywordList is no longer a search condition. The backend
      // skips the criterion when it is absent, so nothing else changes.
      const newCondition = { title: activeCondition.title, status: activeCondition.status, createBy: activeCondition.createBy}
      const result = await bannerService.search(newCondition, newPaginate);

      setDataList(result.list);
      setPagination(result.pagination ? result.pagination : newPaginate);
      setSelectedRowKeys([]);
      setSelectedRows([]);

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  /**
   * NMU-526: clearing the filters has to re-run the search, not just empty the
   * inputs — otherwise the table keeps showing the previous result set while the
   * form claims no filter is applied. Back to page 1, since the banner the user
   * was looking at on page 3 of a filtered list is somewhere else entirely in
   * the full one.
   */
  const onClearSearch = () => {
    const cleared = { ...EMPTY_CONDITION };
    setCondition(cleared);
    doSearch(1, { condition: cleared });
  }

  const onClickEdit = (record) => {
    try {
      dispatch(appLoaderAction.enable());
      setEditData(record);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  }

  const onConfirmDelete = (id) => {
    onDelete(id);
  }

  const onDelete = async (id) => {
    try {
      dispatch(appLoaderAction.enable());
      await bannerService.remove({ deleteIds: [id] });
      dispatch(appLoaderAction.disale());
      notifyUtitls.deleted('สำเร็จ', 'ลบข้อมูลสำเร็จ');
      doSearch(1);
      doSearchDisplay();
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const rowSelection = () => {
    return {
      onChange: (selectedRowKeys, selectedRows) => {
        setSelectedRows(selectedRows);
        setSelectedRowKeys(selectedRowKeys);
      },
      selectedRowKeys,
    };
  }

  const doSearchDisplay = async () => {
    try {
      dispatch(appLoaderAction.enable());

      const result = await bannerService.getDisplay();
      setDisplayList(result.list);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  const onAddToDisplay = () => {
    if (selectedRows.length === 0) {
      notifyUtitls.warning('เพิ่มการแสดงแบนเนอร์', 'กรุณาเลือกแบนเนอร์อย่างน้อย 1 รายการ');
    } else if (displayList.length + selectedRows.length > 5) {
      notifyUtitls.warning('เพิ่มการแสดงแบนเนอร์', 'เพิ่มการแสดงแบนเนอร์เกิน 5 แบนเนอร์');
    } else {
      const compare = selectedRows.filter((item) => {
        return displayList.findIndex((banner) => banner.bannerId === item.bannerId) < 0;
      });
      const newDisplayList = [...displayList, ...compare];

      setDisplayList(newDisplayList);
      setSelectedRows([]);
      setSelectedRowKeys([]);
    }
  }

  const onSaveDisplay = async () => {
    try {
      dispatch(appLoaderAction.enable());

      await bannerService.saveDisplay({ listBean: displayList });

      // Re-read what was actually persisted rather than trusting local state,
      // so the cards match the arrangement the public site will now resolve.
      await doSearchDisplay();

      dispatch(appLoaderAction.disale());
      notifyUtitls.success('สำเร็จ', 'บันทึกการแสดงผลแบนเนอร์สำเร็จ');
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const onClearDisplay = () => {
    doSearchDisplay();
  }

  const onRemoveDisplay = (bannerId) => {
    const newList = [...displayList];
    const index = displayList.findIndex((item) => item.bannerId === bannerId);
    newList.splice(index, 1);
    setDisplayList(newList);
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setDisplayList(arrayMove(displayList, oldIndex, newIndex));
  };

  const renderOptionUser = () => {
    return userList?.map((item) => {
      if (item?.profile) {
        const profile = item.profile;
        return (
          <Select.Option value={item.userId} key={item.userId}>
            {`${profile.firstName} ${profile.lastName}`}
          </Select.Option>
        );
      } else {
        return null
      }
    });
  };

  const onPreview = async () => {
    try {
      dispatch(appLoaderAction.enable());

      // dispatch(bannerPreviewAction.addBannerPreview(displayList));

      await openWebsitePreview({ type: PREVIEW_TYPE.banner, listBean: displayList });
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  }

  const onChangeSelect = (name) => {
    return (value) => {
      setCondition({ ...condition, [name]: value });
    };
  }

  return (
    <div>
      <h2 className="color-primary-title">แบนเนอร์</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการเนื้อหา</Breadcrumb.Item>
        <Breadcrumb.Item>แบนเนอร์</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex justify-content-between">
        <Button type="primary" className="mx-2" onClick={() => onAdd()}>
          <Icon.Plus className="me-1" size={18} /> เพิ่มแบนเนอร์
        </Button>
        <div>
          <Button className="btn-gray" onClick={() => onClearDisplay()}>
            ล้างค่าการแสดงผลแบนเนอร์
          </Button>
          <Button type="primary" className="mx-2" onClick={() => onSaveDisplay()}>
            <Icon.Save className="me-1" size={18} /> บันทึกการแสดงผลแบนเนอร์
          </Button>
          <Button className="mx-2 btn-line" onClick={() => onPreview()}>
            <Icon.Eye className="me-1" size={18} /> ดูตัวอย่างเว็บไซต์
          </Button>
        </div>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]} onChange={callback}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form layout="vertical">
                <Row gutter={20}>
                  <Col span={7}>
                    <Form.Item label="ชื่อแบนเนอร์" className="mb-0">
                      <Input
                        name="title"
                        value={condition.title}
                        onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col>
                  {/* NMU-525: no คีย์เวิร์ด filter here. Keywords are something
                      an editor sets on a banner in the add/edit dialog — they
                      were never a useful way to find one. The dialog keeps its
                      keyword input, and the table keeps its column. */}
                  <Col span={5}>
                    <Form.Item label="ผู้บันทึก" className="mb-0">
                      <Select
                        showSearch
                        // style={{ width: 200 }}
                        placeholder="Search to Select"
                        optionFilterProp="children"
                        allowClear
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        value={condition.createBy}
                        onChange={onChangeSelect('createBy')}
                      >
                        {renderOptionUser()}

                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="สถานะ" className="mb-0">
                      <Select name="status" value={condition.status} onChange={onChangeSelect('status')}>
                        <Option value={null}>All</Option>
                        <Option value={true}>Online</Option>
                        <Option value={false}>Offline</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="mt-4">
                    <Button type="primary" className="w-100" onClick={() => doSearch(1)}>
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button className="btn-gray" onClick={() => onClearSearch()}>ล้างค่า</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>
        <Collapse className="mb-4" defaultActiveKey={["1"]} onChange={callback}>
          <Panel header="การแสดงผลแบนเนอร์ (ได้สูงสุด 5 แบนเนอร์)" key="1">
            {displayList.length > 0 ? (
              <SortableList
                axis={'x'}
                items={displayList}
                onSortEnd={onSortEnd}
                onRemove={onRemoveDisplay}
                groupValue={groupType.BANNER}
              />
            ) : (
              <Empty />
            )}
          </Panel>
        </Collapse>

        <div>
          <Button type="primary" className="mx-2" onClick={() => onAddToDisplay()}>
            <Icon.Plus className="me-1" size={18} /> เพิ่มการแสดงผลแบนเนอร์
          </Button>
        </div>

        <CustomTable
          rowSelection={{
            type: 'checkbox',
            ...rowSelection(),
          }}
          rowKey="bannerId"
          tableName="bannerTable"
          columns={withCreatedColumn(columns, createdColumn)}
          onChangeTable={onChangeTable}
          data={dataList}
          scroll={{ x: true }}
          isPagination={true}
          onChangePage={onChangePage}
          currentPage={pagination.currentPage}
          pageSize={pagination.rowPerPage}
          totalRecord={pagination.rowCount}
        />
      </Card>

      <AddEditBannerDialog
        isShow={isShowAddFileDialog}
        editData={editData}
        onCancel={onCancel}
        onSaveComplete={onSaveComplete}></AddEditBannerDialog>
    </div>
  );
};

export default Banner;
